import { Component, ViewChild } from '@angular/core';
import { TerminalSyncLogModel } from './model/terminal-sync-log.model';
import { MatTableDataSource } from '@angular/material/table';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { TerminalSyncLogService } from './terminal-sync-log.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatSort, SortDirection } from '@angular/material/sort';

@Component({
    selector: 'app-terminal-sync-log',
    templateUrl: './terminal-sync-log.component.html',
    styleUrls: ['./terminal-sync-log.component.scss'],
    standalone: false
})
export class TerminalSyncLogComponent {

    syncLogList: TerminalSyncLogModel[] = [];
    shopListData: any[] = [];
    showSearch: boolean = false;
    isLoading = true;
    filter: FilterListItemModel[] = [
        {
            title: "Shop",
            column: "shop.id",
            type: "list",
            values: [],
        },
        {
            title: "Station Code",
            column: "station_code",
        },
        {
            title: "Station Name",
            column: "station_name",
        },
        {
            title: "Sync Time",
            column: "sync_process_log.updated_at",
            type: "date"
        },
        {
            title: "Status",
            column: "status",
            type: "boolean",
            operators: [
                { title: "is", operator: "=" },
                { title: "is not", operator: "!=" }
            ],
            values: [
                { title: "Failed", value: "0" },
                { title: "Success", value: "1" },
            ]
        },

    ];
    displayedColumns = ['shop_name', 'station_name', 'updated_at', 'status'];
    pagingData = { length: 0, pageSize: 10, pageIndex: 0 };

    isHandset: boolean = false;
    searchColumFilter: SearchParam = {};
    columnSortData: SearchSort[] = [];
    selectedItem?: TerminalSyncLogModel;
    showSummaryPanel: boolean = false;
    selection = new SelectionModel<TerminalSyncLogModel>(true, []);
    dataSource = new MatTableDataSource(this.syncLogList);
    IsDownloading: boolean = false;

    constructor(private breakpointObserver: BreakpointObserver,
        private terminalSyncLogService: TerminalSyncLogService,
        public dialog: MatDialog,
        private snackBarService: SnackBarService,
        private router: Router, private stateManagerService: StateManagerService,
    ) {

        this.syncLogList = [];
    }
    /**
      * initilaize the device model
      */
    ngOnInit(): void {
        this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
            if (state.matches) {
                this.isHandset = true;
            } else {
                this.isHandset = false;
            }
        });
        this.shopList();
        this.isLoading = false; // Set to true on page load
    }
    /** 
     * Set the datasource
     */
    setDataSource(terminalSyncLogModel: TerminalSyncLogModel[]) {
        this.dataSource = new MatTableDataSource(terminalSyncLogModel);
        this.dataSource.sort = this.sort;
    }
    @ViewChild(MatSort) sort!: MatSort;
    @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
    ngAfterViewInit(): void {

        this.loadPreviousState();
    }

    /**
     * loads the previous state if exists
     */
    loadPreviousState(): void {

        var previousState = this.stateManagerService.getState(this.constructor.name);

        if (previousState !== undefined && this.searchFilter != undefined) {

            if (previousState.state.search.filters.scope) {
                this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
                this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
            }

            if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
                this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
            }

            this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
            this.searchFilter.setSearchFilter(this.searchColumFilter, true);

        } else {
            this.setSortColumn('status', 'asc');
            this.loadData();
        }

    }
    /**
     * Sets the sort column
     * @param column 
     * @param direction 
     */
    setSortColumn(column: string, direction: SortDirection): void {
        this.columnSortData.length = 0;
        this.columnSortData.push({ column: column, order: direction });
        this.sort.sort({
            id: column,
            start: direction,
            disableClear: false,
        });

    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.syncLogList.length;
        return numSelected === numRows;
    }

    toggleAllRows() {
        if (this.isAllSelected()) {
            this.selection.clear();
            return;
        }

        this.selection.select(...this.syncLogList);
    }

    /**
     * Create sort order
     * @returns sort criteria
     */
    getSort(): SearchSort[] {
        return this.columnSortData;
    }

    /**
       * Builds the request data to be send to API
       * @returns Request Data
       */
    buildRequestData(): RequestData {
        let searchParam = this.getSearchParam();
        let requestData: RequestData = {
            search: {
                filters: {
                    simpleSearch: searchParam.freeSearch,
                    advSearch: searchParam.advSearch,
                    scope: {
                        limit: this.pagingData.pageSize,
                        offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
                    }
                },
                sort: this.getSort(),
            }
        };

        return requestData;
    }

    /**
      * Set the column filter and reaload the daaa
      * @param columFilter 
      */

    onFilterApplied(columFilter: any): void {
        this.searchColumFilter = columFilter;
        this.loadData();

    }



    /**
     * loads the data based on the conditions
     */
    loadData(): void {
        this.isLoading = true;
        let requestData = this.buildRequestData();
        let response = this.terminalSyncLogService.getList(requestData).subscribe(response => {
            if (response.status == 'SUCCESS') {

                this.syncLogList = response.data.sync_log;           // <— store array
                this.setDataSource(this.syncLogList);                        // <— set data source
                this.pagingData.length = response.data.total_count;

                if (this.pagingData.length == 0) {
                    let snackBarData: SnackBarData = {
                        message: 'No data found. Please remove or change the filter if any.',
                        title: 'No Data!!!',
                        type: 'warn'
                    }
                    this.snackBarService.openSnackBar(snackBarData);
                    this.selectedItem = undefined;
                } else {
                    this.onRowSelected(this.syncLogList[0])
                    this.stateManagerService.setState(this.constructor.name, requestData);
                }
            } else {
                let snackBarData: SnackBarData = {
                    message: response.message,
                    title: 'Failed!!!',
                    type: 'error'
                }
                this.snackBarService.openSnackBar(snackBarData);
            }
            this.isLoading = false;
        });

    }

    shopList(): void {
        let requestData = { search: { filters: { filter: [], scope: { offset: 0, limit: 1000000 } }, sort: [{ column: "shop.name", order: "ASC" }] } };
        this.terminalSyncLogService.getShopList(requestData).subscribe({
            next: (response: any) => {
                this.shopListData = response.data.shops;
                this.filter[0].values = this.shopListData.map((shop: any) => {
                    return { title: shop.name, value: shop.id };
                });
            },
            error: (error: any) => {
                console.error('Error fetching shops:', error);
            }
        });
    }


    /**
    * On terminalSyncLog selected
    * @param terminalSyncLog 
    */
    onRowSelected(terminalSyncLog: TerminalSyncLogModel): void {
        this.selectedItem = terminalSyncLog;
        this.showSummaryPanel = true;
    }

    /**
      *  Set the sort param and relead the data
      * @param $event sort data
      * {"active": "email","direction": "asc"}
      *   
      */
    sortData($event: any): void {
        var sd = this.sort;
        this.columnSortData.length = 0;
        this.columnSortData.push({ column: sd.active, order: sd.direction });
        this.loadData();
    }
    /**
  * Creates the column filter conditions based on search criteria
  * @returns Filter condions for columns
  */
    getSearchParam(): SearchParam {

        return this.searchColumFilter;
    }

    /**
     * 
     * @param event 
     * When page size is changed update paging data
     */
    onPageEvent(event: any): void {

        this.pagingData.pageIndex = event.pageIndex;
        this.pagingData.pageSize = event.pageSize;

        this.loadData();
    }


}